import styled from 'styled-components';

export const SmallerFont = styled.div`
  font-size: smaller;
  width: 100%;
`;
